
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offers/showcase",
      function () {
        return require("private-next-pages/offers/showcase/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/offers/showcase"])
      });
    }
  